import React, { useState, useEffect } from "react";
import { Header } from '../../Components/Layout/Header.jsx';
import { MetaTags } from '../../Components/Layout/MetaTags.jsx';
import RiveComponent from "../../Components/Shared/RiveComponent";

export function SpinsSplash(props) {
    const [button, setButton] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
        props.showMenuFn(false);

        casino.utils.createPageGoogleTagManagerEvent('Bonusi', 'Spins Splash', 'casino', props.user);
    }, []);

    const handleButtonClick = () => {
        setButton(!button);
    }

    return (<>
        <MetaTags title="Spins Splash | SuperSport | SuperCasino" description="Spins Splash SuperSport Casino!" />

        <Header key="header" {...props} />
        <div className="white-background">

            <div className="spins-splash-banner2">
                <section className="spins-splash2 banner--inner selected">
                    <div className="banner--content">
                        <div className="banner--bg-container">
                            <div className="banner--repeater" />
                            <div className="banner--repeater2">
                            </div>
                            <div className="banner--background" />
                        </div>
                        <div className="banner--foreground">
                            <div className="rive-container">
                                <RiveComponent
                                    lazyLoad={true}
                                    cacheBust={`c=${casino.config.guiCacheVerzija}`}
                                    src={`${casino.config.casinoCDNImagesUrl}/Banners/PragmaticSpinSplash/holidayspinsplash_v8_fin.riv`}
                                    stateMachines="State Machine 1"
                                    useOffscreenRenderer={true}
                                    playRequest={true}
                                    disablePlayOutsideViewport={{ target: ".banner--inner", rootMargin: "-50px 0px 0px 0px", threshold: 0.25 }}
                                />
                            </div>
                            <div className="banner--image-left"></div>
                            <div className="banner--image-left-overlay"></div>
                            <div className="banner--text">
                                <a className="red btn medium fill" href="https://mcasino.supersport.hr/?game_category=Spins%20Splash">ZAIGRAJ</a>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div id="page-wrapper">
                <div className="spins-splash-page">

                    <h1 className="text-left">Uključi se u čarobnu Holiday Spins Splash promociju vrijednu <span className="red-text">1 milijun eura!</span> ❄️</h1>
                    <p className="paragraph-bold">
                        Pripremi se za najuzbudljivije vrijeme u godini! Očekuje te pet tjedana fenomenalne Holiday Spins Splash promocije gdje je nagradni fond čak <span className="red-text">1.000.000 €</span>!
                    </p>

                    <div className="tabs-container">
                        <div className="button-container">
                            <button className={`btn-left ${button ? 'btn-disabled' : 'btn-enabled'}`} onClick={handleButtonClick} disabled={button}>Nagrade</button>
                            <button className={`btn-right ${button ? 'btn-enabled' : 'btn-disabled'}`} onClick={handleButtonClick} disabled={!button}>Kako igrati?</button>
                        </div>
                        {button ? <Nagrade /> : <Kako />}
                    </div>

                </div>
            </div>
        </div>
    </>
    )
}

function Nagrade() {

    function ActiveWeek({ weekNumber, startDate, endDate }) {
        return (
            <>
                <div className="active-week">
                    <div className="first-week-from-to">
                        <div className="active-bonus">
                        </div>
                        <div className="first-week-rectangle">
                            <h1>{weekNumber}</h1>
                            <p>TJEDAN</p>
                        </div>
                        <div className="from-to">
                            <p>Od srijede, {startDate} <span className="red-text">u 00:01</span></p>
                            <hr />
                            <p>Do utorka, {endDate} <span className="red-text">u 23:59</span></p>
                        </div>
                        <div className="rewards-container">
                            <div className="first-reward">
                                <p>3000 NAGRADA SA</p>
                                <div className="first-reward-rectangle">
                                    <h1>50</h1>
                                    <p>BESPLATNIH <br /><span>VRTNJI</span></p>
                                </div>
                            </div>
                            <div className="second-reward">
                                <p>8000 NAGRADA SA</p>
                                <div className="second-reward-rectangle">
                                    <h1>20</h1>
                                    <p>BESPLATNIH <br /><span>VRTNJI</span></p>
                                </div>
                            </div>
                            <div className="third-reward">
                                <p>9000 NAGRADA SA</p>
                                <div className="third-reward-rectangle">
                                    <h1>10</h1>
                                    <p>BESPLATNIH <br /><span>VRTNJI</span></p>
                                </div>
                            </div>
                        </div>
                        <div className="bottom-left-visual">
                        </div>
                        <div className="bottom-right-visual">
                        </div>
                    </div>
                </div>
            </>
        )
    }

    const currentDate = new Date();
    //first week start and end
    const firstWeekStartDate = new Date('2023-12-05T00:01:00');
    const firstWeekEndDate = new Date('2023-12-12T23:59:00');
    //second week start and end
    const secondWeekStartDate = new Date('2023-12-13T00:01:00');
    const secondWeekEndDate = new Date('2023-12-19T23:59:00');
    //third week start and end
    const thirdWeekStartDate = new Date('2023-12-20T00:01:00');
    const thirdWeekEndDate = new Date('2023-12-26T23:59:00');
    //forth week start and end
    const forthWeekStartDate = new Date('2023-12-27T00:01:00');
    const forthWeekEndDate = new Date('2024-01-02T23:59:00');
    //fifth week start and end
    const fifthWeekStartDate = new Date('2024-01-03T00:01:00');
    const fifthWeekEndDate = new Date('2024-01-09T23:59:00');

    const isFirstWeekVisible = currentDate < firstWeekStartDate || currentDate > firstWeekEndDate;
    const isSecondWeekVisible = currentDate < secondWeekStartDate || currentDate > secondWeekEndDate;
    const isThirdWeekVisible = currentDate < thirdWeekStartDate || currentDate > thirdWeekEndDate;
    const isForthWeekVisible = currentDate < forthWeekStartDate || currentDate > forthWeekEndDate;
    const isFifthWeekVisible = currentDate < fifthWeekStartDate || currentDate > fifthWeekEndDate;

    return (
        <>
            <div className="rewards">
                <h1 className="text-left">Koje su nagrade?</h1>
                <div className="weeks">
                    {!isFirstWeekVisible ? <ActiveWeek weekNumber="1." startDate="05.12.2023." endDate="12.12.2023." /> :
                        <div className="week">
                            <div className="week-rectangle">
                                <h2>1.</h2>
                                <p>TJEDAN</p>
                            </div>
                            <div className="from-to">
                                <p>Od srijede, 05.12.2023. <span className="red-text">u 15:01</span></p>
                                <p>Do utorka, 12.12.2023. <span className="red-text">u 23:59</span></p>
                            </div>
                            {currentDate < firstWeekEndDate ? <img className="soon" src="Content/Images/Bonusi/SpinsSplash/uskoro.png" alt="Uskoro" />
                                : <img className="finished" src="Content/Images/Bonusi/SpinsSplash/zavrseno.png" alt="Zavrseno" />}
                        </div>
                    }

                    <hr />

                    {!isSecondWeekVisible ? <ActiveWeek weekNumber="2." startDate="13.12.2023." endDate="19.12.2023." /> : 
                        <div className="week">
                            <div className="week-rectangle">
                                <h2>2.</h2>
                                <p>TJEDAN</p>
                            </div>
                            <div className="from-to">
                                <p>Od srijede, 13.12.2023. <span className="red-text">u 00:01</span></p>
                                <p>Do utorka, 19.12.2023. <span className="red-text">u 23:59</span></p>
                            </div>
                            {currentDate < secondWeekEndDate ? <img className="soon" src="Content/Images/Bonusi/SpinsSplash/uskoro.png" alt="Uskoro" />
                                : <img className="finished" src="Content/Images/Bonusi/SpinsSplash/zavrseno.png" alt="Zavrseno" />}
                        </div>
                    }

                    <hr />

                    {!isThirdWeekVisible ? <ActiveWeek weekNumber="3." startDate="20.12.2023." endDate="26.12.2023." /> : 
                        <div className="week">
                            <div className="week-rectangle">
                                <h2>3.</h2>
                                <p>TJEDAN</p>
                            </div>
                            <div className="from-to">
                                <p>Od srijede, 20.12.2023. <span className="red-text">u 00:01</span></p>
                                <p>Do utorka, 26.12.2023. <span className="red-text">u 23:59</span></p>
                            </div>
                            {currentDate < thirdWeekEndDate ? <img className="soon" src="Content/Images/Bonusi/SpinsSplash/uskoro.png" alt="Uskoro" />
                                : <img className="finished" src="Content/Images/Bonusi/SpinsSplash/zavrseno.png" alt="Zavrseno" />}
                        </div>
                    }

                    <hr />

                    {!isForthWeekVisible ? <ActiveWeek weekNumber="4." startDate="27.12.2023." endDate="02.01.2024." /> : 
                        <div className="week">
                            <div className="week-rectangle">
                                <h2>4.</h2>
                                <p>TJEDAN</p>
                            </div>
                            <div className="from-to">
                                <p>Od srijede, 27.12.2023. <span className="red-text">u 00:01</span></p>
                                <p>Do utorka, 02.01.2024. <span className="red-text">u 23:59</span></p>
                            </div>
                            {currentDate < forthWeekEndDate ? <img className="soon" src="Content/Images/Bonusi/SpinsSplash/uskoro.png" alt="Uskoro" />
                                : <img className="finished" src="Content/Images/Bonusi/SpinsSplash/zavrseno.png" alt="Zavrseno" />}
                        </div>
                    }

                    <hr />

                    {!isFifthWeekVisible ? <ActiveWeek weekNumber="5." startDate="03.01.2024." endDate="09.01.2024." /> : 
                        <div className="week">
                            <div className="week-rectangle">
                                <h2>5.</h2>
                                <p>TJEDAN</p>
                            </div>
                            <div className="from-to">
                                <p>Od srijede, 03.01.2024. <span className="red-text">u 00:01</span></p>
                                <p>Do utorka, 09.01.2024. <span className="red-text">u 23:59</span></p>
                            </div>
                            {currentDate < fifthWeekEndDate ? <img className="soon" src="Content/Images/Bonusi/SpinsSplash/uskoro.png" alt="Uskoro" />
                                : <img className="finished" src="Content/Images/Bonusi/SpinsSplash/zavrseno.png" alt="Zavrseno" />}
                        </div>
                    }

                    <hr />

                    <img className="free-spins" src="Content/Images/Bonusi/SpinsSplash/besplatne_vrtnje.png" alt="Besplatne vrtnje čekaju" />

                    <p className="paragraph-bold">
                        Pridruži nam se u ovoj uzbudljivoj avanturi i osiguraj svoj dio od milijun eura! Sretno!
                    </p>
                </div>
            </div>
        </>
    );
}

function Kako() {
    return (<>
        <div className="how-container">
            <h1 className="text-left">Kako igrati?</h1>

            <p className="paragraph-bold">
                U igri je 5 tjedana čiste igre. <br />
                Tjedni nagradni fond od <span className="red-text">200 tisuća eura!</span>
            </p>

            <img className="current-game" src="Content/Images/Bonusi/SpinsSplash/Sweet Bonanza Xmas.png" alt="Sweet Bonanza Xmas" />

            <p>
                Glavna zvijezda zabave je svima poznata <span className="red-text">Sweet Bonanza</span>, a svaki tjedan donosi iznenađenja s drugim uzbudljivim igrama koje će ti začiniti zabavu.
            </p>

            <div className="visual"></div>

            <p className="paragraph-bold no-b-padding">
                Jednostavno odigraj Sweet Bonanza ili bilo koju drugu igru koja sudjeluje taj tjedan u promociji i osvoji svoju nagradu. Bez kompliciranih pravila, samo čista zabava!
            </p>
        </div>
    </>
    );
}